import { JsonRpcProvider } from "ethers"
import { useEnvironmentStore } from "../zustand/environmentStore"

export const useUpdateEnvironment = () => {
    const { rpcUrl, updateBalance, updatePrivateKey, updatePublicKey, updateUserKey } = useEnvironmentStore()
    const provider = new JsonRpcProvider(rpcUrl)

    const handleUpdateEnvironment = async (publicKey: string, privateKey: string, userKey: string | undefined) => {
        updatePublicKey(publicKey)
        updatePrivateKey(privateKey)

        if (userKey) {
            updateUserKey(userKey)
        } else {
            updateUserKey('')
        }

        const currentBalance = await provider.getBalance(publicKey)

        updateBalance(currentBalance)
    }

    return { handleUpdateEnvironment }
}